<template>
	<module-field :bind="$props">
		<span slot="title"></span>
		<div class="input-box">
			<div class="input-checkbox">
				<span class="checkmark-container">
					<label class="checkbox">
						<input type="checkbox" :id="`checkbox_${field.id}`" v-model="inputVal" value="1">
						<span class="checkmark"></span>
					</label>
				</span>
				<label :for="`checkbox_${field.id}`" class="input-checkbox-text">{{ text }}</label>
			</div>
		</div>
	</module-field>
</template>

<script>
import CrudField from '@/mixins/CrudField';

export default {
	mixins: [ CrudField ],

	computed: {
		text() {
			if (this.field.specific_data && this.field.specific_data.length > 0) {
				return this.field.specific_data;
			}

			return `Yes, this ${ this.module.singular_name.toLowerCase() } is active`;
		}
	}
};
</script>
